import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCardCheckboxCheckedGroup: React.FC<SvgProps> = (props) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <rect
        x="0.625"
        y="0.625"
        width="22.75"
        height="22.75"
        rx="2.375"
        fill="#0A1433"
        stroke="#0A1433"
        strokeWidth="1.25"
      />
      <path
        d="M5 12.42L10 17.42L19 8.42L17.59 7L10 14.59L6.41 11.01L5 12.42Z"
        fill="#FCFCFC"
      />
    </g>
  );
};

export const IconCardCheckboxCheckedSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconCardCheckboxCheckedGroup {...props} />
    </svg>
  );
};
